import Button from '../../Components/Button/Button';
import styled from 'styled-components/macro';

export const ButtonWithSpacing = styled(Button)`margin-right: 1rem`;
